import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo-icon">
            <svg viewBox="0 0 32 32" fill="none">
              <rect width="32" height="32" rx="8" fill="#10B981"/>
              <path d="M10 16C10 12.686 12.686 10 16 10C19.314 10 22 12.686 22 16" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
              <path d="M10 16C10 19.314 12.686 22 16 22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="4 4"/>
              <circle cx="16" cy="16" r="2" fill="white"/>
            </svg>
          </div>
          <span className="footer-logo-text">Kalorees</span>
        </div>

        <div className="footer-links">
          <Link to="/bmi-calculator">BMI</Link>
          <Link to="/calorie-intake-calculator">Calories</Link>
          <Link to="/ideal-weight-calculator">Weight</Link>
          <Link to="/calories-burned-calculator">Burned</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </div>

        <div className="footer-copy">
          &copy; {year} Kalorees. Free health calculators.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
